import { render, staticRenderFns } from "./InformationTable.vue?vue&type=template&id=7c65e169&scoped=true&"
import script from "./InformationTable.vue?vue&type=script&lang=js&"
export * from "./InformationTable.vue?vue&type=script&lang=js&"
import style0 from "./InformationTable.vue?vue&type=style&index=0&id=7c65e169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65e169",
  null
  
)

export default component.exports